document.addEventListener("DOMContentLoaded", function () {
  const emailInput = document.getElementById("quiz-email");
  const startBtn = document.getElementById("start-quiz-btn");
  const emailError = document.getElementById("email-error");
  const emailStep = document.getElementById("email-step");
  const quizScreen = document.getElementById("quiz-screen");
  const quizContentArea = document.getElementById("quiz-content-area");
  const resultFormWrapper = document.getElementById("quiz-result-form-wrapper");

  let currentQuestionIndex = 0;
  let allQuestions = [];
  let userAnswers = {};

  if (startBtn) {
    startBtn.addEventListener("click", function () {
      const email = emailInput.value.trim();
      if (validateEmail(email)) {
        emailError.style.display = "none";
        window.quizUserEmail = email;
        emailStep.style.display = "none";
        quizScreen.style.display = "block";
        loadQuiz();
      } else {
        emailError.style.display = "block";
      }
    });
  }

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  }

  function loadQuiz() {
    allQuestions = [];
    quizData.sections.forEach(section => {
      const sectionQuestions = section.questions.map(q => ({
        ...q,
        level: section.level,
        paragraph: section.paragraph || null,
      }));
      allQuestions.push(...sectionQuestions);
    });
    showQuestion(0);
  }

  function showQuestion(index) {
    if (index < 0) return;

    currentQuestionIndex = index;
    const question = allQuestions[index];

    if (!question) {
      generateAndShowResults();
      return;
    }

    const totalQuestionCount = allQuestions.length;
    const currentQuestionNumber = index + 1;

    let instructionText = "";
    if (question.type === "sentence_order") {
      instructionText = "Make the correct sentence order.";
    } else if (question.type === "multiple_choice") {
      instructionText = "Choose the correct answer.";
    } else if (question.type === "fill_in_blank") {
      instructionText = "Fill in the blank.";
    }

    let paragraphHtml = "";
    if (question.paragraph) {
      paragraphHtml = `<div class="rte"><em>${question.paragraph}</em></div>`;
    }

    let html = `<div class="question-card">`;
    html += `<p><strong>Question ${currentQuestionNumber} of ${totalQuestionCount}</strong></p>`;
    if (instructionText) {
      html += `<p class="question-instruction">${instructionText}</p>`;
    }
    html += paragraphHtml;

    const key = `q${index}`;
    if (question.type === "multiple_choice") {
      html += `<p class="quiz-question-text">${question.question}</p>`;
      let optionsHtml = question.options.map((option) => {
        const checked = userAnswers[key] === option ? "checked" : "";
        const optionId = `${key}-${option.replace(/\s+/g, "")}`;
        return `<div class="radio-option-wrapper">
                  <input type="radio" id="${optionId}" name="${key}" value="${option}" ${checked}>
                  <label for="${optionId}">${option}</label>
                </div>`;
      }).join("");
      html += `<div class="form__fields">${optionsHtml}</div>`;
    } else if (question.type === "fill_in_blank" || question.type === "sentence_order") {
      const val = userAnswers[key] || "";
      html += `<p class="quiz-question-text">${question.question}</p>
               <div class="field">
                 <input type="text" name="${key}" value="${val}" placeholder="Your answer" id="q-input-${index}" class="field__input">
                 <label for="q-input-${index}" class="field__label">Your answer</label>
               </div>`;
    }
    html += `</div>`; // .question-card sonu

    html += `<div class="quiz-nav-buttons">`;
    html += `<div class="nav-group-left">`;
    if (index > 0) {
      html += `<button id="prev-btn" class="button button--secondary">Previous</button>`;
    }
    if (currentQuestionNumber < totalQuestionCount) {
      html += `<button id="next-btn" class="button">Next</button>`;
    } else {
      html += `<button id="submit-btn" class="button">Finish & See Results</button>`;
    }
    html += `</div>`;

    html += `<div class="nav-group-right">`;
    if (currentQuestionNumber < totalQuestionCount) {
      html += `<button id="finish-early-btn" class="button button--secondary">Finish Exam</button>`;
    }
    html += `</div>`;
    html += `</div>`;

    quizContentArea.innerHTML = html;
    attachEventListeners();
  }

  function normalizeAnswer(str) {
  return str
    .trim()
    .toLowerCase()
    .replace(/[.,!?;:'"”“]/g, "") 
    .replace(/\s+/g, " ");        
  }

  function generateAndShowResults() {
    let scores = { A1: 0, A2: 0, B1: 0 };
    let questionsInLevel = { A1: 15, A2: 15, B1: 15 };
    let answeredQuestions = { A1: 0, A2: 0, B1: 0 };

    allQuestions.forEach((question, index) => {
      const key = `q${index}`;
      if (userAnswers.hasOwnProperty(key)) {
        if (question && question.level) {
          answeredQuestions[question.level]++;
          if (normalizeAnswer(userAnswers[key]) === normalizeAnswer(question.answer)) {
            scores[question.level]++;
            }
        }
      }
    });

    let finalLevel = "Beginner (A0)";
    let resultMessage = `<h2>A Great Start! 🚀</h2><p>You are at the beginning of a wonderful Dutch learning journey. We recommend starting with our A1 materials.</p>`;

    if (scores.A1 >= 12) {
      finalLevel = "A1";
      resultMessage = `<h2>Great Job! 🥳</h2><p>You have a solid foundation and your estimated level is <strong>A1</strong>. You are ready for our A2 courses.</p>`;
    }
    if (scores.A1 >= 12 && scores.A2 >= 12) {
      finalLevel = "A2";
      resultMessage = `<h2>Excellent! 🎉</h2><p>You have a good command of Dutch and your estimated level is <strong>A2</strong>. Our B1 courses will be a perfect fit for you.</p>`;
    }
    if (scores.A1 >= 12 && scores.A2 >= 12 && scores.B1 >= 12) {
      finalLevel = "B1";
      resultMessage = `<h2>Fantastic! 🤩</h2><p>You have a strong command of the B1 level and your estimated level is <strong>B1</strong>. We can help you prepare for the B2 level.</p>`;
    }

    let emailBody = `New level test completed!\n\n`;
    emailBody += `USER EMAIL: ${window.quizUserEmail}\n\n`;
    emailBody += `--- FINAL RESULT ---\n`;
    emailBody += `Estimated Level: ${finalLevel}\n\n`;
    emailBody += `--- SCORE BREAKDOWN ---\n`;
    emailBody += `A1 Score: ${scores.A1} / ${questionsInLevel.A1} (Answered: ${answeredQuestions.A1})\n`;
    emailBody += `A2 Score: ${scores.A2} / ${questionsInLevel.A2} (Answered: ${answeredQuestions.A2})\n`;
    emailBody += `B1 Score: ${scores.B1} / ${questionsInLevel.B1} (Answered: ${answeredQuestions.B1})\n\n`;
    emailBody += `--- DETAILED ANSWERS ---\n`;
    emailBody += JSON.stringify(userAnswers, null, 2);

    const resultHtmlForUser = `<div class="quiz-result">${resultMessage}</div>`;

    quizScreen.innerHTML = resultHtmlForUser;

    document.getElementById('QuizResultEmail').value = window.quizUserEmail;
    document.getElementById('QuizResultLevel').value = finalLevel;
    document.getElementById('QuizResultScore').value = `A1: ${scores.A1}, A2: ${scores.A2}, B1: ${scores.B1}`;
    document.getElementById('QuizResultAnswers').value = JSON.stringify(userAnswers, null, 2);
    resultFormWrapper.style.display = 'block';

    attachResultFormListeners();
  }

  function attachEventListeners() {
    document.querySelectorAll("#quiz-content-area input").forEach((input) => {
      const saveAnswer = () => {
        const key = input.name;
        if (input.type === "radio") {
          if (input.checked) userAnswers[key] = input.value;
        } else {
          userAnswers[key] = input.value;
        }
      };
      input.addEventListener("change", saveAnswer);
      input.addEventListener("input", saveAnswer);
    });

    const prevBtn = document.getElementById("prev-btn");
    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        showQuestion(currentQuestionIndex - 1);
      });
    }

    const nextBtn = document.getElementById("next-btn");
    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        showQuestion(currentQuestionIndex + 1);
      });
    }

    const submitBtn = document.getElementById("submit-btn");
    if (submitBtn) {
      submitBtn.addEventListener("click", generateAndShowResults);
    }

    const finishEarlyBtn = document.getElementById("finish-early-btn");
    if (finishEarlyBtn) {
      finishEarlyBtn.addEventListener("click", generateAndShowResults);
    }
  }

  function attachResultFormListeners() {
    const consentCheckbox = document.getElementById('QuizConsentCheckbox');
    const submitBtn = document.getElementById('QuizSubmitBtn');

    if (consentCheckbox && submitBtn) {
      consentCheckbox.addEventListener('change', function () {
        submitBtn.disabled = !this.checked;
      });
    }
  }
});